export default "__VITE_ASSET___4Kldsk7__"